export default Object.freeze({
    // 
    PRODUCT_ID_SINGLE_PLAN: '1',
    PRODUCT_ID_PREMIUM_PLAN: '2',
});